module.exports = "pegasus/assets/circle-twitter-old.png";